// extracted by mini-css-extract-plugin
module.exports = {"back-to-top":"b_","backToTop":"b_"};